











































































































































import { Component, Mixins, Prop } from 'vue-property-decorator'
import { IFormStore } from '@/store/types'
import { kintaiPatternStore } from '@/store/form/KintaiPatternFormStore'
import FormStoreComponent from '@/tcw/components/FormStoreComponent'
import { KeyInfo } from '@/components/common/form/types'
import { ApiGeneralObjectArrayPayload, ApiGeneralSinglePayload, CodeLabel } from '@/tcw/api/types'
import {
  KEY_CLASS_GYOUSHU_CODE,
  KEY_CLASS_KINMU_KEITAI,
  KEY_CLASS_KINMU_JIKAN_KEISAN_TYPE
} from '@/tcw/constant/KeyClass'
import * as ApiPath from '@/tcw/constant/ApiPath'
import Jikan from '@/tcw/domain/Jikan'

@Component
export default class KintaiPatternForm extends Mixins(FormStoreComponent) {
  @Prop({ default: '' })
  private patternId!: string

  protected gyoushuList: CodeLabel[] = []
  protected kinmuKeitaiList: CodeLabel[] = []
  protected shugyouKeitaiCodeList: CodeLabel[] = []
  protected koutsuhiPattern: ApiGeneralSinglePayload | null = null
  protected koutsuhiPatternList: ApiGeneralObjectArrayPayload = []

  get formName(): string {
    return 'kintaiPatternForm'
  }
  get storeModule(): IFormStore<ApiGeneralSinglePayload> {
    return kintaiPatternStore
  }
  get keyInfo(): KeyInfo {
    return { id: this.patternId }
  }

  get form(): ApiGeneralSinglePayload {
    return kintaiPatternStore.editData !== null ? kintaiPatternStore.editData : {}
  }

  get kaishiValue(): Jikan | null {
    if (typeof this.form.kaishi !== 'string') {
      return null
    }
    return Jikan.generateByJikanStr(this.form.kaishi)
  }
  set kaishiValue(newJikan: Jikan | null) {
    const updateValue = newJikan ? newJikan.toString() : null
    this.updateValue('kaishi', updateValue)
    this.updateValue('kintaiJikan', updateValue === null || this.shuryoValue === null ? null : 'OK')
  }

  get shuryoValue(): Jikan {
    if (typeof this.form.shuryo !== 'string') {
      return new Jikan(18, 0)
    }
    const jikan = Jikan.generateByJikanStr(this.form.shuryo)
    return jikan ? jikan : new Jikan(18, 0)
  }
  set shuryoValue(newJikan: Jikan) {
    const updateValue = newJikan.toString()
    this.updateValue('shuryo', updateValue)
    this.updateValue('kintaiJikan', this.kaishiValue === null || updateValue === null ? null : 'OK')
  }

  protected getKoutsuhiPattern(patternId: string): void {
    const targetKoutsuhi = this.koutsuhiPatternList.find(
      koutsuhi => String(koutsuhi.id) === patternId
    )
    this.koutsuhiPattern = targetKoutsuhi ? targetKoutsuhi : null
  }

  get koutsuhiPatternOptions(): CodeLabel[] {
    return this.koutsuhiPatternList.map(pattern => {
      return {
        code: Number(pattern.id),
        label: String(pattern.patternName)
      }
    })
  }

  protected async afterProc(): Promise<void> {
    this.gyoushuList = await this.codeLabel.getCodeLabelList(KEY_CLASS_GYOUSHU_CODE)
    this.kinmuKeitaiList = await this.codeLabel.getCodeLabelList(KEY_CLASS_KINMU_KEITAI)
    this.shugyouKeitaiCodeList = await this.codeLabel.getCodeLabelList(
      KEY_CLASS_KINMU_JIKAN_KEISAN_TYPE
    )
    await this.fetchKoutsuhiPatternList()

    this.updateValue(
      'kintaiJikan',
      this.kaishiValue === null || this.shuryoValue === null ? null : 'OK'
    )
    if (this.isEmptyRecord) {
      // 勤務時間計算をユーザ情報からコピー
      this.updateValue(
        'shugyouKeitaiCode',
        this.$tcw.session.user && this.$tcw.session.user.shugyouKeitaiCode
      )
    }
  }

  protected async fetchKoutsuhiPatternList(): Promise<void> {
    try {
      const response = await this.getWebApi().call<ApiGeneralObjectArrayPayload>(
        ApiPath.Paths.KoutsuhiPatternList.get,
        'GET'
      )
      this.koutsuhiPatternList = response
    } catch (e) {
      this.$tcw.message({
        message: '交通費パターンが取得できませんでした',
        type: 'success'
      })
      console.log('error ocuread')
    }
  }
}
